import React, { useState } from "react";
import Modal from 'react-modal';
import { v4 as uuidv4 } from 'uuid';
import Transcribe from "./transcribe";
import AWS from 'aws-sdk'
import {decode, encode} from 'base-64';


AWS.config.update({
    accessKeyId: 'AKIAQ4YFCCA6AYXRD7W6',
    secretAccessKey: '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'
});

//const S3_BUCKET = 'photos64';
//testing before demo
const S3_BUCKET = 'photos64-cf';
const REGION = 'us-east-1';

const myBucket = new AWS.S3({
    params: { Bucket: S3_BUCKET },
    region: REGION,
});

export default function SearchPhotos() {

    const [query, setQuery] = useState("");
    const [keyword, setkeyword] = useState("");
    const [pics, setP] = useState([]);
    const [file, setf] = useState();
    const [fileUrl, setU] = useState();
    const [varx, setIsOpen] = useState(false);


    function submit() {
        let myHeaders = new Headers();
        let filename_split = file.name.split('.')
        let file_extension = filename_split[filename_split.length-1]
        myHeaders.append("x-amz-meta-customLabels", keyword);
        myHeaders.append("Content-Type", `image/${file_extension}`);
        // myHeaders.append("Access-Control-Request-Headers", "*");
        // myHeaders.append("Access-Control-Allow-Headers", "*");
        // myHeaders.append("Access-Control-Allow-Origin", "*");
        //3gYXXNIxH6aWngK7EDKULt8AXUuo9is7pCPOsXMi
        myHeaders.append("x-api-key", "3gYXXNIxH6aWngK7EDKULt8AXUuo9is7pCPOsXMi");

        let requestOptions = {
            // crossDomain: true,
            method: 'PUT',
            headers: myHeaders,
            // data: encode(file),
            body: file
        };
        // const reader = new FileReader();

        

        // const params = {
        //     Body: file,
        //     Bucket: S3_BUCKET,
        //     Key: `${file.name}`,
        //     Metadata: {
        //         "x-amz-meta-customLabels": keyword
        //     }
        // };

        // myBucket.putObject(params)
        //     .on('httpUploadProgress', (evt) => {
        //         console.log(evt)
        //     })
        //     .send((err) => {
        //         if (err) {
        //             alert(err);
        //         } else {
        //             setf(null);
        //             alert(`File uploaded`);
        //         }
        //     })
        // close()

        // return
        fetch(" https://jrahim6z9j.execute-api.us-east-1.amazonaws.com/v1/upload/photos64-cf/" + file.name.toString(), requestOptions)
            .then(response => response.text())
            .then(result => {
                console.log(result)
                setIsOpen(false);
            })
            .catch(error => console.log('error', error));

    }

    // function upload1() {
    //     var filePath = (document.getElementById('uploaded_file').value).split("\\");
    //     var fileName = filePath[filePath.length - 1];
    //     var fileExt = fileName.split(".").pop();

    //     if (!document.getElementById('custom_labels').innerText == "") {
    //         var customLabels = document.getElementById('custom_labels');
    //     }
    //     console.log(fileName);
    //     console.log(custom_labels.value);

    //     var file = document.getElementById("uploaded_file").files[0];
    //     file.constructor = () => file;

    //     console.log(file.type);

    //     var sdk = apigClientFactory.newClient();

    //     var params = {
    //         'x-amz-meta-customLabels': custom_labels.value,
    //         "filename": fileName,
    //         "bucket": "photo2store",
    //         //'x-amz-meta-customLabels': {"labels": custom_labels.value},
    //         //'x-amz-meta-customabels': custom_labels.value,
    //         // "x-api-key": "RAbQGlfiCt1Bdfphacz04348WPcYUnhs8ja4u89C"
    //     };

    //     var additionalParams = {
    //         headers: {
    //             //'x-amz-meta-customLabels': custom_labels.value,
    //             'Content-Type': file.type,
    //             //'policy': ["starts-with", "$x-amz-meta-customLabels", ""]
    //         }
    //     };

    //     var reader = new FileReader();
    //     reader.onload = function (event) {
    //         body = btoa(event.target.result);
    //         //console.log('Reader body : ', body);
    //         return sdk.uploadBucketFilenamePut(params, file, additionalParams)
    //             .then(function (result) {
    //                 console.log(result);
    //                 alert('Image uploaded successfully')
    //             })
    //             .catch(function (error) {
    //                 console.log(error);
    //             })
    //     }
    //     reader.readAsBinaryString(file);

    //     document.getElementById('uploaded_file').value = "";
    //     document.getElementById('custom_labels').value = "";

    //     // var url = "https://wajuqrne5c.execute-api.us-east-1.amazonaws.com/v1/upload/photos-st3523/duck.jpeg"
    //     // axios.put(url, file, params).then(response => {
    //     //     alert("Image uploaded: " + file.name);
    //     // })
    //     // .catch(function(error) {
    //     //     console.log(error);
    //     // });   
    // }

    function change(e) {
        console.log(e.target.files);
        setf(e.target.files[0])
        setU(URL.createObjectURL(e.target.files[0]))
    }

    function open() {
        setIsOpen(true);
    }

    function close() {
        setU(null)
        setkeyword("")
        setP([])
        setf('')
        setIsOpen(false);
    }
    // apiAPIGateway 3gYXXNIxH6aWngK7EDKULt8AXUuo9is7pCPOsXMi

    const searchPhotos = () => {
        let myHeaders = new Headers();

        // myHeaders.append("x-amz-meta-customLabels", keyword);
        // myHeaders.append("Content-Type", "application/json");
        // myHeaders.append("Access-Control-Allow-Origin", "*");
        myHeaders.append("X-Api-Key", "3gYXXNIxH6aWngK7EDKULt8AXUuo9is7pCPOsXMi");

        let requestOptions = {
            crossDomain: true,
            method: 'GET',
            headers: myHeaders,
            // data: file,
        };

        console.log("query value : ", query)
        let getUrl = " https://jrahim6z9j.execute-api.us-east-1.amazonaws.com/v1/search?q=" + query
        console.log("testing")

        fetch(getUrl, requestOptions)
            .then(response => response.json())
            .then(data => {
                console.log("-----", data)
                // setP(data["results"]["results"])
                // JSON.parse(data['body'])['results']['results']
                // setP(JSON.parse(data['body'])['results']['results'])
                // setP(JSON.parse(data['body'])['results']['results'])
                console.log(data['results']['results'])
                if (data["results"].length !== 0) {
                    setP(data["results"]["results"])
                }
                else
                    alert(" No Pictures")
            });
    };

    return (
        <div className="container-fluid p-5">
            <div className={"row"}>
                <div className={"col-9"}>
                    <div className="form-group row">
                        <div className="col-sm mt-4">
                            <input type="text" name="query" className="form-control" id="query"
                                placeholder={`Try "test" or "apple"`}
                                value={query}
                                onChange={(e) => setQuery(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className={"col mt-4 p-0"}>
                    <Transcribe setQuery={setQuery} />
                </div>
                <div className={"col mt-4 p-0"}>
                    <button type="submit" onClick={searchPhotos} className="btn btn-primary">
                        Search
                    </button>
                </div>
                <div className={"col mt-4 p-0"}>
                    <button onClick={open} className="btn btn-primary">
                        Upload
                    </button>
                </div>

            </div>
            <br />
            <div >
                {pics.map((pic) => (
                    <div key={pic.url}>
                        <img
                            src={pic.url}
                            width="80%"
                            height="50%"
                            alt="pic"
                        ></img>
                    </div>
                ))}{" "}
            </div>
            <Modal
                isOpen={varx}
                onRequestClose={close}
                contentLabel="Example Modal">
                <div className={"upload"} style={{ padding: "20px" }}>
                    <h2>Add Image:</h2>
                    <input
                        type="text"
                        name="keywords"
                        className="input"
                        placeholder={`Keyword with commas`}
                        style={{ marginRight: "20px", borderRadius: 5 }}
                        value={keyword}
                        onChange={(e) => setkeyword(e.target.value)}
                    />
                    <input type="file" onChange={change} />
                    <br />
                    <br />

                    <img src={fileUrl} width={"40%"} height={"40%"} />
                    <br /><br />

                    <button onClick={submit} className="btn btn-primary">
                        Submit
                    </button>
                    <button onClick={close} className="btn btn-primary ">
                        Close
                    </button>
                </div>
            </Modal>
        </div>
    );
}
